// ============================================
// COMPANYCOMPETENCIESPAGE.JSX - Company Competencies Sub-Page
// ============================================

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetCompanyByIdQuery } from "../../../services/api";
import CompetencySetSection from "./CompetencySetSection";
import CompetencyRubricAdmin from "./CompetencyRubricAdmin";
import { IconCircle, IconCheck } from "./components/Icons";
import MetricsGrid from "./components/MetricsGrid";
import "./CompanyDetails.css";

/**
 * CompanyCompetenciesPage Component
 * Sub-page for managing company competencies and rubrics
 */
export default function CompanyCompetenciesPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch company data for name
  const { data: companyData } = useGetCompanyByIdQuery(id);
  const companyName = companyData?.name || "Loading...";

  // Competency-specific metrics
  const metrics = [
    { icon: <IconCircle />, label: "Competencies", value: "05" },
    { icon: <IconCheck />, label: "Completed Rubrics", value: "02" },
  ];

  return (
    <div className="cd-company-details">
      <div className="welcome" onClick={() => navigate(`/admin/companies/${id}`)}>
        ← Back to {companyName}
      </div>
      <h1 className="username">{companyName} - Competencies</h1>

      <MetricsGrid metrics={metrics} />

      <CompetencySetSection companyId={id} />
      <CompetencyRubricAdmin companyId={id} />
    </div>
  );
}
